import { inject } from '@angular/core';
import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { AUTH_SELECTORS } from '../store/selectors/auth.selectors';
import { filter, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IRootState } from '../store/reducers/root.reducer';

export const signInGuard = (): MaybeAsync<GuardResult> => {
  const store = inject(Store) as Store<IRootState>;
  const router = inject(Router);

  return combineLatest([
    store.select(AUTH_SELECTORS.discoveryDocumentLoaded),
    store.select(AUTH_SELECTORS.userProfileLoaded),
  ]).pipe(
    filter(([docLoaded, userLoaded]) => docLoaded && userLoaded),
    switchMap(() => store.select(AUTH_SELECTORS.isAuthenticated)),
    map((isAuth) => (isAuth ? router.createUrlTree(['']) : true)),
  );
};
